import React, { useEffect } from 'react';
import './PdfPreviewModal.css';

const PdfPreviewModal = ({ blobUrl, loading, error, onClose, onDownload }) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  return (
    <div className="pdf-modal-overlay" onClick={onClose}>
      <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="pdf-modal-header">
          <h3>Aperçu du carnet</h3>
          <div className="pdf-modal-actions">
            {blobUrl && (
              <>
                <button onClick={() => window.open(blobUrl, '_blank')?.print()}>
                  🖨 Imprimer
                </button>
                <button onClick={onDownload}>
                  ⬇ Télécharger
                </button>
              </>
            )}
            <button className="btn-close-modal" onClick={onClose}>✕</button>
          </div>
        </div>
        <div className="pdf-modal-body">
          {loading && <div className="pdf-loading">Génération du PDF…</div>}
          {error && <div className="pdf-error">{error}</div>}
          {blobUrl && !loading && (
            <iframe
              src={blobUrl}
              title="Aperçu PDF"
              width="100%"
              height="100%"
              style={{ border: 'none' }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PdfPreviewModal;
